export const legendItems = [
  { label: 'Día', color: '#84fff5' },
  { label: 'Noche', color: '#e8a2fe' },
  { label: 'Tránsito', color: '#FFC400' },
  { label: 'Incendio', color: '#FF0000' },
  { label: 'Descanso', color: '#FFFF00' }
]
